import { CmtsMasterDataCrudShell } from "../components/master-data/index.js";

export function CmtsPriorityPage() {
  return <CmtsMasterDataCrudShell entityKey="priority" />;
}

export default CmtsPriorityPage;
